function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 7.22h1.57c.62 0 .97.52.78 1.1-.11.33-.38.5-.78.51H13.6v1.59c0 .6-.48.95-1.06.78a.72.72 0 01-.53-.72V9.06v-.23H10.39c-.43-.01-.73-.26-.78-.64-.06-.43.11-.78.46-.9.13-.05.26-.06.39-.06H12V6.9 5.7c0-.56.3-.88.8-.87.5 0 .79.32.79.88v1.52zM5.2 0h4.37c.6 0 .95.47.79 1.05a.69.69 0 01-.57.53l-.36.03H.74C.25 1.55-.02 1.23 0 .73.02.3.33 0 .8 0h4.4zM5.2 4.02h4.37c.6 0 .95.46.79 1.05-.08.3-.32.5-.63.54H.9c-.11 0-.23 0-.33-.02-.4-.1-.6-.45-.55-.9a.71.71 0 01.7-.67h4.5zM3.59 9.63H.83c-.55 0-.86-.34-.83-.88a.72.72 0 01.64-.7c.07-.02.15-.03.22-.03h5.47c.62 0 .96.42.84 1.01-.07.37-.37.6-.8.6H3.6z"
});

function SvgComparison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "currentColor",
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparison);
export default __webpack_public_path__ + "static/media/comparison.e022f7bb.svg";
export { ForwardRef as ReactComponent };